var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCartWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "25px",
    viewBox: "0 0 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shopping-cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product_Full",
    transform: "translate(-786.000000, -868.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(756.000000, 847.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(30.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35513825,19.2890509 C6.73099457,19.2890509 5.40984173,20.5699129 5.40984173,22.1445255 C5.40984173,23.719138 6.73104494,25 8.35513825,25 C9.97928193,25 11.3004348,23.7187962 11.3004348,22.1445255 C11.3004348,20.5702547 9.97928193,19.2890509 8.35513825,19.2890509 Z M8.35513825,23.2520472 C7.72548543,23.2520472 7.21308038,22.7555619 7.21308038,22.1448184 C7.21308038,21.534075 7.72548543,21.0375896 8.35513825,21.0375896 C8.98509326,21.0375896 9.49719611,21.534075 9.49719611,22.1448184 C9.49719611,22.7555619 8.98509326,23.2520472 8.35513825,23.2520472 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0547035,19.2890509 C17.4302576,19.2890509 16.1091048,20.5699617 16.1091048,22.1445255 C16.1091048,23.719138 17.430308,25 19.0547035,25 C20.678545,25 22,23.7190892 22,22.1445255 C22,20.5699617 20.678545,19.2890509 19.0547035,19.2890509 Z M19.0547035,23.2517543 C18.4247485,23.2517543 17.9123434,22.7549759 17.9123434,22.1445255 C17.9123434,21.534075 18.4247485,21.0375896 19.0547035,21.0375896 C19.6843563,21.0375896 20.1967613,21.5337821 20.1967613,22.1445255 C20.1967613,22.7552689 19.6846585,23.2517543 19.0547035,23.2517543 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06279371,18.4152211 L21.0980785,18.4152211 C21.5963816,18.4152211 21.9996978,18.0239117 21.9996978,17.5410982 C21.9996978,17.0582847 21.5960794,16.6669753 21.0980785,16.6669753 L7.82948743,16.6669753 L5.24812238,1.31640717 C5.18622482,0.948681812 4.8910908,0.659667556 4.51270481,0.595849067 L1.0564638,0.0130842163 C0.564456251,-0.069679623 0.0989402492,0.248826881 0.013572985,0.724316124 C-0.0720964641,1.20014716 0.256731186,1.65263831 0.747177451,1.73540215 L3.57134815,2.21152616 L6.1728085,17.6815282 C6.24412416,18.1049177 6.62069704,18.4152211 7.06279371,18.4152211 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.837858,5.35568613 C22.6789327,5.13211337 22.4258399,5 22.1561099,5 L5,5 L5,6.73076737 L20.9987641,6.73076737 L19.2631696,12.2692326 L6.20937826,12.2692326 L6.20937826,14 L19.8782747,14 C20.2444344,14 20.5693076,13.7570912 20.6815262,13.3994231 L22.9596442,6.13014217 C23.0420289,5.86683389 22.9967362,5.57896885 22.837858,5.35568613 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartWhite);
export default __webpack_public_path__ + "static/media/shopping-cart-white.9532247123170850bb9d2c36dd4a933a.svg";
export { ForwardRef as ReactComponent };